import { render, staticRenderFns } from "./TypeChecklistItemForm.vue?vue&type=template&id=3fd87973&"
import script from "./TypeChecklistItemForm.vue?vue&type=script&lang=js&"
export * from "./TypeChecklistItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports